import { SubContractorSiteHandoverStateTypes, SubContractorSiteHandoverActionTypes } from "./SubContractorSiteHandover.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: SubContractorSiteHandoverStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const SubContractorSiteHandoverReducer = (
  state: SubContractorSiteHandoverStateTypes = INITIAL_STATE,
  action: any
): SubContractorSiteHandoverStateTypes => {
  switch (action.type) {
    case SubContractorSiteHandoverActionTypes.FETCH_ALL_SUBCONTRACTOR_SITE_HANDOVER:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case SubContractorSiteHandoverActionTypes.FETCH_ALL_SUBCONTRACTOR_SITE_HANDOVER_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case SubContractorSiteHandoverActionTypes.FETCH_ALL_SUBCONTRACTOR_SITE_HANDOVER_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case SubContractorSiteHandoverActionTypes.FETCH_ALL_SUBCONTRACTOR_SITE_HANDOVER_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case SubContractorSiteHandoverActionTypes.FETCH_ONE_SUBCONTRACTOR_SITE_HANDOVER:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case SubContractorSiteHandoverActionTypes.FETCH_ONE_SUBCONTRACTOR_SITE_HANDOVER_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case SubContractorSiteHandoverActionTypes.FETCH_ONE_SUBCONTRACTOR_SITE_HANDOVER_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case SubContractorSiteHandoverActionTypes.FETCH_ONE_SUBCONTRACTOR_SITE_HANDOVER_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default SubContractorSiteHandoverReducer;
